// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "notes-" + "commons" + ".js?v=" + "e0c530f5d8c1be739ea0" + "";
};